import { Box, Typography } from '@mui/material';

function formatFullDateTime(value: number | string): string {
  return new Date(typeof value === 'number' ? value * 1000 : value).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export interface PriceChartHoverLabelProps {
  x: number | null;
  timestamp: number | string | undefined;
}

export function PriceChartHoverLabel({ x, timestamp }: PriceChartHoverLabelProps) {
  if (x === null || !timestamp) {
    return null;
  }

  const formattedTimestamp = formatFullDateTime(timestamp);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: -32,
        left: x,
        transform: 'translateX(-50%)',
        pointerEvents: 'none',
        bgcolor: 'background.paper',
        borderRadius: 1,
        px: 1,
        py: 0.5,
        boxShadow: 2,
        border: '1px solid',
        borderColor: 'divider',
        zIndex: 10,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '0.7rem',
          color: 'text.secondary',
          whiteSpace: 'nowrap',
        }}
      >
        {formattedTimestamp}
      </Typography>
    </Box>
  );
}
